<template lang="pug">
  .item-list
    .item-list__search.container
        SearchBox(
          :placeholder="searchPlaceholder"
          v-model="searchQuery"
        )
    .container
      PlaceholderTip.item-list__search-tip(
        v-if="isShowSearchTip"
        text="Ничего не найдено"
        icon="search"
      )
      ul.item-list__list
        slot
</template>

<script>
import SearchBox from "@/components/SearchBox.vue";
import PlaceholderTip from '@/components/PlaceholderTip.vue';

export default {
  components: {
    SearchBox,
    PlaceholderTip
  },
  props: {
    searchPlaceholder: {
      type: String,
      default: 'Поиск',
    },
    isShowSearchTip: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  watch: {
    searchQuery(newValue) {
      this.$emit('input', newValue);
    }
  },
};
</script>
